<template>
    <div>
        <van-swipe :autoplay="3000" :show-indicators="false">
            <van-swipe-item v-for="(images, index) in images" :key="index">
                <div class="images">
                    <img v-lazy="images.image" style="width:100%" />
                </div>
            </van-swipe-item>
        </van-swipe>
        <div class="content">
            <line-title title="代理产品"></line-title>
            <!-- <div class="hotTitle">
                <div class="hotLine"></div>
                <span class="title">热销产品</span>
            </div> -->
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onload"
                >
                <van-cell v-for="(item,index) in list" :key="index">
                    <cell-list :productInfo="item"></cell-list>
                </van-cell>
            </van-list>
        </div>
        <div class='jishu'><i></i><a href="tel:02988852911" >技术支持：西安力邦睿特信息技术有限公司</a><i></i></div>
        <tabbar :active="active"></tabbar>
    </div>
</template>

<script>
import tabbar from "@/components/agentTabbar"
import cellList from "@/components/cellList"
import lineTitle from "@/components/lineTitle"
import {wxLogin,getLogout} from '@/utils/util'
export default {
    data() {
        return {
            active:"agentProductList",//底部导航栏默认选中
            images: [],
            activeName:"a",
            list:[],
            finished:false,
            loading:false,
            page:1,
            timer:null
        };
    },
    created(){
        document.title="保险商城";
        this.getBanner();
    },
    methods: {
        getBanner(){
            this.$https.fetchPost("Slides/agent",{},{headers:{"XX-Token":this.$store.state.token}})
            .then(result=>{
                if(result.data.code==1){
                    this.images=result.data.data;
                    console.log(result.data)
                }else{
                    Toast(data.msg);
                }
            })
        },
        more(){
            console.log("跳转到产品库")
        },
        onload(){
            if(!this.timer){
                this.timer = setTimeout(() => {
                    this.getList()       //请求列表数据的方法
                    this.timer = null;
                }, 200)
            }
        },
        getList(){
            this.$https.fetchPost("Goods/index",{"page":this.page},{headers:{"XX-Token":this.$store.state.token}})
            .then(result=>{
                let data=result.data;
                if(data.code==10001){  //有token,返回用户未登陆情况
                    this.$store.commit("LOGOUT")
                    this.$router.push("/login")
                }
                if(data.code==1 && data.data.length!=0){
                    this.list=[...this.list,...result.data.data];
                    this.loading = false;
                    this.page++;
                }else{
                    this.finished = true;
                }
            })
        },
    },
    components:{
        tabbar,
        cellList,
        lineTitle
    },
}
</script>

<style scoped>
.jishu{
    text-align:center;
    padding:30px 0 30px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .jishu i{
      width:50px;
      height:2px;
      background-color:#eee;
      display:inline-block;
      margin:0 10px;
      vertical-align:baseline;
  }
  .jishu a{
      text-decoration:none;
      color:#666;
      font-size:12px;
      -webkit-tap-highlight-color:transparent;
  }
 .content{
    /* padding: 12px; */
    text-align: start;
    margin-top: 17px;
  }
   .images{
      max-height: 240px;
  }
  .van-cell{
      padding:0;
      background: transparent;
  }
   .hotTitle{
    margin-left: 12px;
    height: 16px;
    display: flex;
    align-items: center;
    margin-top: 25px;
    margin-bottom: 8px;
  }
  .title{
      font-size: 15px;
      color: #333;
      font-weight: bold;
  }
  .hotLine{
    display: inline-block;
    width: 5px;
    height: 100%;
    border-radius: 3px;
    margin-right: 4px;
    background: -webkit-linear-gradient(rgba(255,255,255,1),rgba(227,50,43,1)); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(rgba(255,255,255,1),rgba(227,50,43,1)); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(rgba(255,255,255,1),rgba(227,50,43,1)); /* Firefox 3.6 - 15 */
    background: linear-gradient(rgba(255,255,255,1),rgba(227,50,43,1)); /* 标准的语法 */
  }
</style>


// WEBPACK FOOTER //
// src/views/agentProduct/agentProductList.vue